export default __webpack_public_path__ + "static/media/flag-abkhazia.3883bcab.svg";